import _ from 'lodash';
import { useState, createElement, Fragment } from 'react';
import { connect } from 'react-redux';

import { BYR_SET_ROOF_ID } from '../Actions';
import CTAButton from '../CTAButton';
import Modal from '../Modal';
import { DataTrack } from '../Utilities';
import { SchemaForm } from '../forms/InnerSchemaForm';
import { connectLocation } from '../location/LocationConnectors';

// reducer lives in ./reducers so the Store doesn't pull this UI module in;
// re-exported here for existing consumers
export { byrConfigReducer } from './reducers';

export const VariableButton = props => {
  const { t, byrConfig } = props;
  if (_.get(byrConfig, 'slug')) {
    // eslint-disable-next-line max-len
    const formUrl = `www.owenscorning.com/en-us/roofing/contractors/fac-email-me?meta_contractor=${byrConfig.membership_number}&meta_byr_slug=${byrConfig.slug}&meta_byr_id=${byrConfig.roofId}`;
    const [opened, setOpened] = useState(false);

    return (
      <>
        <DataTrack track="form-start" form-name="email-contractor" professional="contractor">
          <CTAButton onClick={() => setOpened(true)}>Contact</CTAButton>
        </DataTrack>
        <Modal open={opened} onClose={() => setOpened(false)} size="sm">
          <h4>{t('build_your_roof.contact')}</h4> <h5>{byrConfig.companyName}</h5>
          <SchemaForm uid={formUrl} />
        </Modal>
      </>
    );
  }
  return createElement(CTAButton, props);
};
export const VariableCTAButton = connectLocation(connect(state => ({ byrConfig: state.byrConfig }))(VariableButton));

export const connectComponentOverrides = (component, path) => {
  const connector = connect(state => ({
    overrides: _.get(state, path, {}),
  }));
  return connector(component);
};

export const connectOrder = connect(({ byrConfig }) => ({
  stepOrder: byrConfig.stepOrder,
}));
export const setRoofId = roofId => ({ type: BYR_SET_ROOF_ID, roofId });
export const ConfigurationConnector = connect(({ byrConfig }) => ({ configuration: byrConfig }), { setRoofId });
